@if (!isPdf() && !isDocument()) {
  <div
    class="position-relative"
    (click)="togglePreview()"
    (mouseleave)="closePreview()"
  >
    <div class="image-container">
      <img
        [src]="imgSrc() || ''"
        alt=""
        class="attachment__thumbnail"
        [class]="'rotate-' + attachment().rotate"
      />
    </div>
    @if (previewOpen) {
      <div class="attachment-preview">
        <img
          [src]="imgSrc() || ''"
          alt=""
          [class]="'rotate-' + attachment().rotate"
        />
      </div>
    }
  </div>
}
@if (isPdf() || isDocument()) {
  <div class="d-flex">
    @if (isPdf() && isDocument()) {
      <p class="pdf mb-0 semibold me-2">PDF</p>
    }
    @if (isImg()) {
      <div class="image-container">
        <img
          [src]="imgSrc() || ''"
          alt=""
          class="attachment__thumbnail__document"
        />
      </div>
    }
    @if (isDocument() && !isPdf() && !isImg()) {
      <i
        (click)="clickOnImage()"
        class="attachment-icon icon icon--document"
      ></i>
    }
  </div>
}
